/**
 * Forms Module
 * 
 * @package KateMedia
 */

export function initForms() {
    const forms = document.querySelectorAll('.form');
    
    forms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const formData = new FormData(this);
            const formObject = {};
            
            formData.forEach((value, key) => {
                formObject[key] = value;
            });
            
            if (validateForm(formObject)) {
                showMessage('Спасибо! Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время.', 'success');
                this.reset();
            }
        });
    });
}

function validateForm(data) {
    // Простая валидация
    const requiredFields = ['name', 'company', 'email', 'phone', 'format'];
    
    for (let field of requiredFields) {
        if (!data[field] || data[field].trim() === '') {
            showMessage(`Пожалуйста, заполните поле "${field}"`, 'error');
            return false;
        }
    }
    
    // Валидация email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
        showMessage('Пожалуйста, введите корректный email адрес', 'error');
        return false;
    }
    
    return true;
}

function showMessage(message, type = 'info') {
    // Создаем элемент сообщения
    const messageElement = document.createElement('div');
    messageElement.className = `form-message form-message--${type}`;
    messageElement.textContent = message;
    
    // Добавляем стили
    messageElement.style.cssText = `
        padding: 15px;
        margin: 10px 0;
        border-radius: 5px;
        font-weight: 500;
        ${type === 'success' ? 'background-color: #d4edda; color: #155724; border: 1px solid #c3e6cb;' : ''}
        ${type === 'error' ? 'background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb;' : ''}
        ${type === 'info' ? 'background-color: #d1ecf1; color: #0c5460; border: 1px solid #bee5eb;' : ''}
    `;
    
    // Вставляем сообщение перед формой
    const form = document.querySelector('.form');
    if (form) {
        form.parentNode.insertBefore(messageElement, form);
        
        // Удаляем сообщение через 5 секунд
        setTimeout(() => {
            if (messageElement.parentNode) {
                messageElement.parentNode.removeChild(messageElement);
            }
        }, 5000);
    }
}
